import React from 'react';
import { PageHero } from '../components/layout/PageHero';
import { SectionHeading } from '../components/ui/SectionHeading';
import { DownloadCard } from '../components/ui/DownloadCard';
import { CtaBand } from '../components/ui/CtaBand';
import { resourceItems } from '../data/media';
export function Resources() {
  return <>
      <PageHero eyebrow="Campaign toolkit" title="Everything you need to campaign in your ward." intro="Graphics, posters, explainer cards and guides — free to download, print and share. Please do not alter the brand assets." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Resources'
    }]} data-id="element-1335" data-mp="t3s6t5ae2sma" />

      <section className="bg-sand-50 py-16 lg:py-24" aria-labelledby="toolkit-heading" data-id="element-1336" data-mp="16x1covz4ow02">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1337" data-mp="1bvurqsu2cv2c">
          <SectionHeading eyebrow="Downloads" title="Campaign materials" data-id="element-1338" data-mp="3rk4kdagus4b2" />
          <ul className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-1339" data-mp="f4j73263r5k">
            {resourceItems.map(item => <li key={item.title} data-id="element-1340" data-mp="21rthtn4tfwva">
                <DownloadCard item={item} data-id="element-1341" data-mp="21t4obupnbiq3" />
              </li>)}
          </ul>
        </div>
      </section>

      <section className="bg-white py-14 lg:py-20" aria-labelledby="usage-heading" data-id="element-1342" data-mp="2bp7v5dvg05jd">
        <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-1343" data-mp="2bmv84matv4zg">
          <div className="rounded-media border border-sand-200 bg-sand-100 p-8" data-id="element-1344" data-mp="26ojz2dscwyia">
            <h2 id="usage-heading" className="font-display text-[24px] text-ink" data-id="element-1345" data-mp="2kourhl9bel5k">
              Three rules for using campaign materials
            </h2>
            <ol className="mt-5 grid gap-5 md:grid-cols-3" data-id="element-1346" data-mp="2ufpmpf4jgv35">
              {[['Do not alter the assets', 'Colours, proportions and wording must stay as issued.'], ['Do not add other branding', 'Materials must not appear to endorse any other organisation.'], ['Report misuse', 'If you see altered materials circulating, tell the campaign immediately.']].map(([title, detail]) => <li key={title} data-id="element-1347" data-mp="36jbhot85oesf">
                  <h3 className="font-display text-[18px] text-ink" data-id="element-1348" data-mp="36fxhnrmysho5">{title}</h3>
                  <p className="mt-1.5 text-[14px] leading-relaxed text-slate-600" data-id="element-1349" data-mp="3bhmvff1kn9fx">{detail}</p>
                </li>)}
            </ol>
          </div>
        </div>
      </section>

      <CtaBand title="Printing for your ward?" description="Registered coordinators can request bulk printed materials through the state campaign office." primary={{
      label: 'Become a coordinator',
      to: '/join'
    }} secondary={{
      label: 'Contact your state office',
      to: '/contact'
    }} data-id="element-1350" data-mp="3l8hfccrchwy7" />
    </>;
}